export const generateRegions = (request, map) => {
  const id = request.regionId;
  const rating = Number(request.rating);

  if (!id) {
    return;
  }

  const entity = map.get(id) || {
    name: request.regionName ?? 'Не указано',
    value: 0,
    id,
    percent: 0,
    rating: 0,
    ratingCount: 0,
  };

  entity.value += 1;

  if (!isNaN(rating)) {
    entity.rating += rating;
    entity.ratingCount += 1;
  }

  map.set(id, entity);
};
